import * as React from "react";

function SvgHitTail(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 210 173.1"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <linearGradient
        id="HitTail_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={493.615}
        y1={-323.461}
        x2={493.615}
        y2={-415.691}
        gradientTransform="matrix(1 0 0 -1 -392 -256)"
      >
        <stop offset={0} stopColor="#188de9" />
        <stop offset={1} stopColor="#126bb0" />
      </linearGradient>
      <path
        d="M186.8 166.2l-30-23.4-13.2 23.8L93.2 80l95.8 25.8-19.4 19.8 33.7 23.8C189.3-13.5 65.7 59.5 0 0c36.2 189.3 149.3 178.7 189.7 168.4l-2.9-2.2z"
        fill="url(#HitTail_svg__a)"
      />
    </svg>
  );
}

export default React.forwardRef(SvgHitTail);
